import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue"
import Icon from "@/components/widgets/icons/Icon.vue"
import {
  MissionContractPayment,
  MissionContractPaymentState,
  UpdateMissionContractPaymentMutationMutation,
  UpdateMissionContractPaymentMutationMutationVariables,
  UpdateMissionContractPaymentMutation,
} from "@/gql"
import MenuDropdown, { ActionType } from "@/components/widgets/common/MenuDropdown.vue"
import MoneyDisplay from "@/components/feature/MoneyDisplay.vue"
import { useMutation } from "@/hooks/useMutation"
import { useNotification } from "@/hooks/useNotification"
import { RefetchQueryDescription } from "apollo-client/core/watchQueryOptions"
import ConfirmProcessingModal from "./ConfirmProcessingModal.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentMilestones',
  props: {
    payment: null,
    preview: { type: Boolean },
    refetchQueries: null
  },
  emits: ["edit"],
  setup(__props: any, { emit }) {

const props = __props as {
  payment: MissionContractPayment
  preview?: boolean
  refetchQueries: RefetchQueryDescription
}




const { mutate } = useMutation()
const { addSuccess } = useNotification()

const showPaidConfirmDialog = ref(false)
const isSubmitting = ref(false)
const isPaymentProcessing = props.payment.state === MissionContractPaymentState.Processing
const isPaymentPending = props.payment.state === MissionContractPaymentState.Pending
const showProcessingDialog = ref(false)
const actions = [
  {
    text: "Edit",
    handler: (item: any) => {
      emit("edit", item)
    },
    disabled: [MissionContractPaymentState.Paid, MissionContractPaymentState.Processing].includes(
      props.payment.state
    ),
  },
  (isPaymentProcessing || isPaymentPending) && {
    text: "Update status to paid",
    handler: () => {
      showPaidConfirmDialog.value = true
    },
  },
  (props.payment.invoiceUrl || props.payment.checkoutUrl) && {
    text: "View invoice",
    handler: () => {
      const url = props.payment.invoiceUrl || props.payment.checkoutUrl
      if (url) {
        window.open(url, "_blank")
      }
    },
  },
  isPaymentPending && {
    text: "Initiate payment processing",
    handler: () => {
      showProcessingDialog.value = true
    },
  },
].filter(Boolean) as ActionType[]

const onUpdatePayment = async () => {
  isSubmitting.value = true

  const result = await mutate<
    UpdateMissionContractPaymentMutationMutation,
    UpdateMissionContractPaymentMutationMutationVariables
  >({
    mutation: UpdateMissionContractPaymentMutation,
    variables: {
      missionContractPaymentId: props.payment.prn,
      state: MissionContractPaymentState.Paid,
      description: props.payment.description,
      amount: props.payment.amount.amount,
    },
    refetchQueries: props.refetchQueries,
    done: () => {
      isSubmitting.value = false
    },
  })

  if (result?.data && !result.data.updateMissionContractPayment.error) {
    showPaidConfirmDialog.value = false
    addSuccess("Payment status updated successfully!")
  }
}

const getRecordIcon = (state: MissionContractPaymentState) => {
  const map: Record<MissionContractPaymentState, string> = {
    [MissionContractPaymentState.Paid]: "check-circle",
    [MissionContractPaymentState.Processing]: "history-3",
    [MissionContractPaymentState.Pending]: "clock-circle",
  }

  return map[state] || "record"
}

return { __sfc: true,props, emit, mutate, addSuccess, showPaidConfirmDialog, isSubmitting, isPaymentProcessing, isPaymentPending, showProcessingDialog, actions, onUpdatePayment, getRecordIcon, Icon, MenuDropdown, MoneyDisplay, ConfirmProcessingModal }
}

})